export default "__VITE_ASSET__DtRNXukB__"